/* eslint-disable no-underscore-dangle */
/* eslint-disable global-require */
import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import states from '../state'
import { buildReducers } from './reducers'

import reduxLogger from './reduxLogger'

const allReducers = combineReducers({ ...buildReducers(states) })

let rde: any

if (typeof window !== 'undefined' && window && window?.__REDUX_DEVTOOLS_EXTENSION__) {
  rde = window?.__REDUX_DEVTOOLS_EXTENSION__()
}

const appStore = createStore(allReducers, rde || {})

reduxLogger(appStore as any)

export default appStore
